export default {
    query : state => state.query,

    queryFields : state => state.queryFields,

    selectedTopicFacetItems : state => state.selectedTopicFacetItems,
};
